const forbiddenError = () => {
  window.location.href = '/organization';
};

export default forbiddenError;
